<template>
  <div class="columns" v-if="!loggingIn">
    <div class="column">
      <h2>Log In </h2>
      <form>
        <b-field label="Email">
          <b-input placeholder="emailaddress@mail.com" type="text" v-model.trim="email" @keyup.native.enter="login"></b-input>
        </b-field>
        <b-field label="Password">
          <b-input placeholder="Password" type="password" v-model.trim="password" @keyup.native.enter="login"></b-input>
        </b-field>
        <a href="#">Forgot Your Password?</a>
        <div class="message is-danger" v-if="error">
          <div class="message-body">The username or password you entered is not correct</div>
        </div>
      </form>

      <div class="login-register">
        <button class="button" type="button" @click="login">
          Log In
        </button>
        <br>
        <br>
        <a @click="$router.push('/register')">Register</a>
      </div>

    </div>
  </div>
  <loader v-else></loader>
</template>

<style scoped>
h2 {
  margin-bottom: 10%;
  text-align: center;
}

.columns {
  max-width: 800px;
  margin: auto;
  padding: 0% 5% 0% 5%;
}
.login-register {
  padding-top: 5%;
  text-align: center;
  margin: auto;
}
</style>
<script>
import BField from 'buefy/src/components/field/Field';
import BMessage from 'buefy/src/components/message/Message';
import Loader from '../Loader';

export default {
  components: {
    Loader,
    BMessage,
    BField,
  },
  name: 'Login',

  data() {
    return {
      email: '',
      password: '',
      error: false,
      loggingIn: false,
    };
  },

  watch: {
    loggedIn() {
      if (this.loggedIn) this.loggingIn = false;
    },
  },

  methods: {
    login() {
      this.loggingIn = true;

      this.$store
        .dispatch('auth/login', {
          email: this.email,
          password: this.password,
        })
        .then(() => this.$router.replace('/admin/0'))
        .catch((err) => {
          this.error = true;
          this.loggingIn = false;
          console.error('err', err.response);
        });
    },
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.user !== undefined;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue